module.exports = __webpack_public_path__ + "static/media/CARTOONAROONY 4.d34349da.JPG";